module.exports = __webpack_public_path__ + "images/Group-18.svg";